import { AccountHistory } from "@/modules/account/components";
import { PageHeader } from "@/shared/components";

export const AccountHistoryPage = () => {
  return (
    <div className="full-width page-container">
      <PageHeader/>
      <AccountHistory/>
    </div>
  );
};
